import mongoose from 'mongoose';
import Protektor from '@iris-platform/protektor';
import { MongoAdapter as ProtektorMongoAdapter } from '../protektor';
import roleIdentifierComparator from '../util/roleIdentifierComparator';

// TODO: Come up with a cleaner way of handling injected configuration
let _config = {}; // eslint-disable-line

export const configure = (logger, config) => new Promise((resolve, reject) => {
  _config = config;

  // Connect to database
  let connectionURL = 'mongodb://';

  config.databaseURI.forEach((dbURI) => {
    connectionURL
        += connectionURL === 'mongodb://' || connectionURL.substr(-1) === '@' ? dbURI : `,${dbURI}`;
  });
  connectionURL += `/${config.databaseName}`;
  logger.info(`Connecting to database URI: ${connectionURL}`);

  const options = {
    autoIndex: false,
    reconnectTries: Number.MAX_VALUE,
    reconnectInterval: 500,
    poolSize: 10,
    bufferMaxEntries: 0,
    keepAlive: true,
    useFindAndModify: false,
    useNewUrlParser: true,
    useUnifiedTopology: true,
  };

  if (config.databaseReplSet !== '') {
    options.replicaSet = config.databaseReplSet;
  }

  if (config.dbUser !== undefined && config.dbUser !== null && config.dbUser !== '') {
    options.user = config.dbUser;
    options.pass = config.dbPassword;
  }

  mongoose.connection.on('connected', () => {
    logger.info('Successfully connected to database');

    Protektor.registerAdapter(new ProtektorMongoAdapter());
    Protektor.registerRoleIdentifierComparator(roleIdentifierComparator);

    resolve(mongoose);
  });

  mongoose.connection.on('error', (error) => {
    logger.error(`Database error: ${error}`);
    reject(error);
  });

  mongoose.connect(connectionURL, options);
});

// Ensure that the exported config is read-only, and
// always references the current _config object
export default new Proxy({}, { get: (obj, prop) => _config[prop] });
